import { api } from "@/services/api"
import { useMutation } from "@tanstack/react-query"
import type { Params } from "@/services/api/cronos/auth/login/code"

export default function useLoginByCode() {
  const mutation = useMutation({
    mutationKey: ["login-by-code"],
    mutationFn: async (params: Params) => api.cronos.auth.login.code(params),
  })

  return mutation
}
